import { Skeleton } from '@/common/components/ui/skeleton';

export const OrgSettingsTabSkeleton = () => (
  <div className="space-y-6 max-w-xl">
    <div className="rounded-2xl border border-border bg-card p-6">
      <div className="space-y-4">
        <Skeleton className="h-10 w-full rounded-md" />
        <Skeleton className="h-10 w-full rounded-md" />
        <div className="grid grid-cols-2 gap-4">
          <Skeleton className="h-10 w-full rounded-md" />
          <Skeleton className="h-10 w-full rounded-md" />
        </div>
        <Skeleton className="h-10 w-full rounded-md" />
        <Skeleton className="h-9 w-[120px] rounded-md" />
      </div>
    </div>
    <Skeleton className="h-[130px] rounded-2xl" />
  </div>
);
